import { getProgress } from "../../store/actions/milestonesActions";
import queryString from 'query-string';
import Loader from "../../components/Loader";
import { startLoading, stopLoading } from "../../store/actions/uiActions";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ProgressReport from "./ProgressReport";
import MilestonesReportePage from "./MilestonesReportePage";
import ErrorPage from "../errors/ErrorPage";


const ReportPage = () => {
    const dispatch = useDispatch();
    const queryParams = queryString.parse(window.location.search, {decode: true});
    const hasFetchData = useRef(false);
    const { loading } = useSelector((state:any) => state.ui);
    const { report_type } = useSelector((state:any) => state.milestones);
    
    const [lang, setLang] = useState<any>("es");

    useEffect(() => {

        async function getData(){
            try{
                dispatch( startLoading() );
                await dispatch(getProgress(queryParams));
                setTimeout(() => {
                    dispatch( stopLoading() );
                },3000)
            } catch(err){
                console.error(err);
                dispatch( stopLoading() );
            }
        }

        if(!hasFetchData.current){
            const { language } = queryParams;
            setLang(language)
            getData();
            hasFetchData.current = true;
        }

    },[dispatch, queryParams]);

    if(loading){
        return <Loader />
    }

    if(report_type === 'age_level'){
        return <ProgressReport language={lang}/>
    }

    if(report_type === 'botnar'){
        return <MilestonesReportePage language={lang} />
    }

    return <ErrorPage />;
}

export default ReportPage
